import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import {Helmet} from 'react-helmet';
import moment from 'moment';
import { pdf as PDFRenderer }from '@react-pdf/renderer';

import Box from '../../components/common/Box';
import { projectsActions } from '../../data/actions/projects';
import TransactionTypes from '../../components/common/Stats/TransactionTypes';
import EntityCard from '../../components/common/EntityCard';
import EntitiesList from '../../components/pages/home/EntitiesList';
import TerritoryStats from '../../components/common/Stats/Territory';
import DemographicsStats from '../../components/common/Stats/Demographics';
import DevicesStats from '../../components/common/Stats/Devices';
import SourcesStats from '../../components/common/Stats/Sources';
import VendorsWidget from '../../components/pages/home/VendorsWidget';
import SharePage from '../../components/pages/sharedPages/SharePage';
import CSV from '../../helpers/CSVExport';
import { dspLogos } from "../../components/common/Stats/utils";
import PDFDocument from '../../components/pages/projects/PDF';

const downloadSvg = require('!svg-inline-loader!../../../public/img/download.svg');

class ProjectDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            cardResolved: false,
            name: null
        };
        this.setParentEntity = this.setParentEntity.bind(this);
        this.exportToPdf = this.exportToPdf.bind(this);
    }

    componentDidMount() {
        const { match, dispatch } = this.props;
        this.setState({id: match.params.id}); //, name: match.params.name 
    }

    componentWillReceiveProps(nextProps){
        const { match } = nextProps;
        if(match.params.id != this.state.id) {
            this.setState({id: null, name: null, artist: undefined, artistId: undefined, cardResolved: false}, ()=>{
                this.setState({id: match.params.id}); //, name: match.params.name 
            });
        }        
    }

    setParentEntity(entity) {
        entity = entity || {};
        this.setState({
            cardResolved: true,
            name: entity.title,
            code: entity.project,
            artist: entity.artist,
            artistId: entity.artist_id,
            released: entity.first_released ? moment(entity.first_released).format('YYYY-MM-DD'): 'N/A',
            title: `${entity.title} (${entity.project}) - project by ${entity.artist}`,
        })
    }

    exportToCsv = () => {
      const {
        products,
        tracks,
        stats
      } = this.props,
      { id } = this.state;

      const data = [
        {top_products: products.top[id].data},
        {top_tracks: tracks.top[id].data},
        {top_territories: stats.territories[id].data.table},
        {top_plaforms: stats.vendors[id].data.table},
        {top_transactions: stats.transactions[id]}
      ];

      const filename = CSV.CSVHeader('project_details', this.state.id, this.props.filter.global, null, this.state.name);

      CSV.CSVBulkExport(data, filename);

    }
    
    getPdfData() {
        const reportTitle = 'Product Details',
            { products, tracks, stats } = this.props,
            { id } = this.state;
            
        const imageIDs = [
              'top_territories_pie_chart',
              'top_vendors_pie_chart',
        ];
        let images = {};
        for (let imageID of imageIDs){
            let image = document.getElementById(imageID);
            if(image)
                images[imageID] = image.toDataURL("image/jpeg,1.0"); 
        }
        
        let vendorTableData = [];

        if (this.props.stats.vendors)
            vendorTableData = stats.vendors[id].data.table;
            
        const { name, artistId, code, released } = this.state;
        const artist = this.state.cardResolved ? (this.state.artist || 'Unlisted Artist') : '';
        
        const overview = [
            {title: "Project", value: name},
            {title: "Artist", value: artist},
            {title: "Code", value: code},
            {title: "First Released", value: released}
        ]

        const tables = {
            products: products.top[id].data,
            tracks: tracks.top[id].data,
            territories: stats.territories[id].data.table,
            vendorsTable: vendorTableData,
            transactions: stats.transactions[id],
            overview
        };
        return { reportTitle, images, tables, overview: stats.top, globalFilter: this.props.filter.global };
    }

    exportToPdf() {
        const data = PDFRenderer(<PDFDocument data={this.getPdfData()} />);
        data.toBlob()
        .then(blob=>{
            const fileURL = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = `${CSV.CSVHeader('project_details', this.state.id, this.props.filter.global)}.pdf`;
            link.click();
        });
    }
    

    render() {
        if(!this.state.id)
            return null;
        
        const { name, artistId, code, released } = this.state;
        const artist = this.state.cardResolved ? (this.state.artist || 'Unlisted Artist') : '';
        //let metaTitle = name ? `${name} - ` : '';
        //const { name, id } = this.state;
        const metaTitle = `Project Details - ${code} - ${name}`;
        
        const { sharedMode } = this.props;
        const { previousPeriodSet: prevPeriod } = this.props.filter.global;
        
        return <div className="project-details artist-profile homepage">
        
            <div className="container">
                <div className="row download-page download-page--mt">
	                <span>Export the data</span>
	                {sharedMode && <a key="download" title="Download entire page" onClick={this.exportToCsv} className="download-link" dangerouslySetInnerHTML={{__html: downloadSvg}} />}
                    {!sharedMode && <SharePage entity="projects" id={this.state.id} exportToCsv={this.exportToCsv} exportToPdf={this.exportToPdf} CSVEntities={["top_products", "top_tracks", "territories", "top_vendors"]}   flatCSVExport={true} />}
	            </div>                
                <div className="main-artist-holder">
                    <div className="main-artist-name-holder">
                        <div className="main-artist-image">
                            <EntityCard entity="projects" id={this.state.id} onResult={this.setParentEntity} showLink={true} />
                        </div>
                        <h3 className="middle-title">{name || (this.state.cardResolved ? '' : 'Loading...')}</h3>
                    </div>
                    <div className="main-artist-details main-artist-details--three-col">
                        <div className="main-artist-details-item">
                            <div className="main-artist-details-title">Artist</div>
                            <div className="main-artist-details-value">{artist}</div>
                        </div>
                        <div className="main-artist-details-item">
                            <div className="main-artist-details-title">Project</div>
                            <div className="main-artist-details-value">{code}</div>
                        </div>
                        <div className="main-artist-details-item">
                            <div className="main-artist-details-title">First Released</div>
                            <div className="main-artist-details-value">{released}</div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 pd-0 default">
                        <TransactionTypes entity="projects" id={this.state.id} parentEntityName={this.state.name} />
                    </div>
                </div>                        
                <div className="row">
                    <div className="col-xs-12 pd-0 default">
                        <EntitiesList trends={true} title="Top Products" entity="products" parentEntity="projects" parentEntityIDs={this.state.id}  parentEntityTitle={this.state.title} parentEntityName={this.state.name} addTotal={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 pd-0 default">
                        <EntitiesList trends={true} title="Top Tracks" entity="tracks" parentEntity="projects" parentEntityIDs={this.state.id}  parentEntityTitle={this.state.title} parentEntityName={this.state.name} addTotal={true} externalLinks={!sharedMode} prevPeriod={prevPeriod} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 pd-0 default">
                        <TerritoryStats entity="projects" ids={this.state.id}  parentEntityTitle={this.state.title} parentEntityName={this.state.name} chartType={dspLogos.territories.id} prevPeriod={prevPeriod} />
                    </div>
                </div>                    
                <div className="row">
                    <div className="col-xs-12 pd-0 default">
                        <VendorsWidget entity="projects" id={this.state.id} parentEntityTitle={this.state.title} parentEntityName={this.state.name} prevPeriod={prevPeriod} />
                    </div>
                </div>
                <Helmet>
                    <title>{metaTitle}</title>
                </Helmet>
            </div>
        </div>
    }
}

function mapStateToProps(state) {
    return {
        projects: state.projects,
        filter: state.filter,
        stats: state.stats,
        products: state.products,
        tracks: state.tracks
    }
}

export default connect(mapStateToProps)(ProjectDetails)
